import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { App } from "@capacitor/app";

const HOME_PATH = "/home";

function BackButtonHandler() {
  const location = useLocation();
  const navigate = useNavigate();
  const locationRef = useRef(location);
  const exitFlagRef = useRef(false);
  const [showExitToast, setShowExitToast] = useState(false);

  useEffect(() => {
    locationRef.current = location;
  }, [location]);

  useEffect(() => {
    const listenerPromise = App.addListener("backButton", ({ canGoBack }) => {
      const pathname = locationRef.current.pathname;

      if (pathname === HOME_PATH) {
        if (exitFlagRef.current) {
          App.exitApp();
        } else {
          exitFlagRef.current = true;
          setShowExitToast(true);
          setTimeout(() => {
            exitFlagRef.current = false;
            setShowExitToast(false);
          }, 2000);
        }
      } else if (canGoBack) {
        window.history.back();
      } else {
        navigate(HOME_PATH);
      }
    });

    return () => {
      listenerPromise.then((listener) => listener.remove());
    };
  }, [navigate]);

  if (!showExitToast) return null;

  return (
    <div className="fixed bottom-6 left-1/2 -translate-x-1/2 bg-gray-900 text-white text-sm px-5 py-2.5 rounded-full z-[2000] shadow-lg">
      ऐप से बाहर जाने के लिए दोबारा Back दबाएं
    </div>
  );
}

export default BackButtonHandler;